module.exports = __webpack_public_path__ + "static/media/iconChat.927867ba.svg";